import CashRegister from "@/types/CashRegister";
import { defineStore } from "pinia";

export const useStore = defineStore("cashRegister", {
  state: () => {
    return {
      selected: null as CashRegister | null,
    };
  },
  actions: {
    initFromStorage() {
      const selected = localStorage.getItem("cash-registers.selected");

      if (selected) {
        this.selected = JSON.parse(selected);
      }
    },
    select(register: CashRegister | null) {
      this.selected = register;

      if (register) {
        localStorage.setItem(
          "cash-registers.selected",
          JSON.stringify(register)
        );
      } else {
        localStorage.setItem("cash-registers.selected", "");
      }
    },
  },
});
